import { useQuery } from '@tanstack/react-query';
import { projects } from '@/utils/api';

export function useProjects(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['projects', params],
    queryFn: () => projects.getAll(params).then((r) => r.data),
  });
}

export function useProject(id: number | string | undefined) {
  return useQuery({
    queryKey: ['projects', id],
    queryFn: () => projects.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}
